<template>
    <div>
        <b-modal
                id="notification-details-popup"
                ref="modal"
                :title="title"
                size="sm"
                hide-footer
                modal-class="hide-footer"
                no-close-on-backdrop
                no-close-on-esc
                :hide-header-close="loading"
        >
            <div style="height: 400px; overflow-y: auto;">
                <div :style="{ whiteSpace: 'pre-wrap'}" style="padding: 10px 30px ; font-size: 14px; color: #424141;">{{ description }}</div>

                <!-- <p
                        style="padding: 10px 30px ; font-size: 14px; color: #424141;"
                >
                    {{ description }}
                </p> -->
            </div>
            <!-- <div class="col-md-12 action-buttons">
                <b-button
                        type="button"
                        variant="primary"
                        class="primary-add-btn"
                        @click="onConfirmPopup"
                        :disabled = "loading"
                >
                    <span class="btn-text">{{ confirmText }}</span>
                    <span class="loader"></span>
                </b-button>
            </div> -->

        </b-modal>
    </div>
</template>

<script>
    import { mapGetters } from "vuex";


    export default {
        components: {},

        /*
        |--------------------------------------------------------------------------
        | Component > props
        |--------------------------------------------------------------------------
        */
        props: {
            title:{
                type:String,
                default: 'Confirmation',
            },
            description:{
                type:String,
                default: 'Are you sure, You want to Resend Email?',
            },
            confirmText: {
                type: String,
                default: 'Ok',
            },
            cancelText: {
                type: String,
                default: 'Cancel',
            },
            onConfirm:{
                type:Function,
                default: ()=>{}
            },
            onCancel:{
                type:Function,
                default: ()=>{}
            },
        }, // End of Component > props
        /*
        |--------------------------------------------------------------------------
        | Component > data
        |--------------------------------------------------------------------------
        */

        data() {
            return {
            };
        },
        /*
        |--------------------------------------------------------------------------
        | Component > computed
        |--------------------------------------------------------------------------
        */
        computed: {
            ...mapGetters(["loading", "selectedItem","dataSegmentId"]),

        }, // End of Component > computed
        /*
        |--------------------------------------------------------------------------
        | Component > watch
        |--------------------------------------------------------------------------
        */
        watch: {
        }, // End of Component > watch

        mounted() {

            console.log(this.selectedItem)
        },
        methods: {
            async onConfirmPopup(){
                await this.onConfirm()
                this.$bvModal.hide('notification-details-popup')
            },
            async onCancelPopup() {
                await this.onCancel();
                this.$bvModal.hide('notification-details-popup')
            },
        }
    };
</script>
